import { render } from "./CollaboratorsView.vue?vue&type=template&id=780fa8d8"
import script from "./CollaboratorsView.vue?vue&type=script&lang=js"
export * from "./CollaboratorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__